export default __webpack_public_path__ + "static/media/scaleFaster.b08bd4b2.png";